
<script>
import Layout from '@/router/layouts/main';
import WorkOrderInfo from './main.vue';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'WorkOrder',
  },
  components: {
    Layout,
    WorkOrderInfo,
  },
};
</script>

<template>
  <Layout :title="$t('general.manage')">
    <WorkOrderInfo :workOrderIdPublic="this.$route.params.idPublic" />
  </Layout>
</template>

